import lodash from "lodash";
import { createManageSelect, createPage } from "../../../../../utils/page";
import { createLoading } from "../../../../../utils/loading";
import { createColumnInlineInput, createColumnInput } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker } from "../../../../../utils/form";
import { onMounted } from "vue";

export const { isLoading, setIsLoading } = createLoading();

export const createColumns = ({ props, data }) => {
    const { viewOnly, productsKey, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push(
        createColumnInput({
            visible: () => productsKey === "refInformProduct",
            title: () => i18n.global.t("model.freeSale.freeSaleProducts.invoiceCode"),
            dataIndex: `${productsKey}.invoiceCode`,
            align: "center"
        })
    );
    columns.push(
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.freeSaleProducts.tradeNameEn"),
            dataIndex: `${productsKey}.tradeNameEn`,
            visible: () => productsKey === "refHazDiscuss",
            align: "center"
        })
    );
    columns.push(
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.freeSaleProducts.tradeNameEn"),
            dataIndex: `${productsKey}.refHaz.tradeNameEn`,
            visible: () => productsKey === "refInformProduct",
            align: "center"
        })
    );
    columns.push(
        createColumnInlineInput({
            title: () => i18n.global.t("model.freeSale.freeSaleProducts.approveCode"),
            dataIndex: `${productsKey}.registrationNumber`,
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key, record }) => {
                return lodash.merge(
                    { disabled: viewOnly },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key, record } } })
                );
            },
            width: 150
        })
    );
    columns.push(
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.freeSaleProducts.productType"),
            dataIndex: `${productsKey}.productType`,
            visible: () => true,
            align: "center"
        })
    );
    return columns;
};

export const initData = ({ props, data, refs }) => {
    const { itemsKey, menuContext, viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data, refs });
    data.page = createPage({ data: items, options: { sort: [{ name: "approveCode", type: "ASC" }] } });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageSelect({
            menuContext,
            type: "radio",
            force: true,
            visible: () => modelRef.refToWhomTemp?.refHazDiscuss?.refResult.isFact && modelRef.refToWhomTemp?.refObjective?.key === "2",
            rowSelection: true,
            autoOk: true,
            onClick: ({ rowSelection }) => {
                const forms = rowSelection.selectedRows.map(d => ({ ...d }));
                modelRef.refToWhomTemp.refInformProduct = forms?.[0].refInformProduct;
            },
            getCheckboxProps: ({ record }) =>  ({ disabled: viewOnly || ![undefined, "draft", "reEdit"].includes(modelRef.refStatus?.key) || (record.refInformProduct?.refToWhom != null && modelRef.refToWhomTemp?.refCountry?.nameEnS === record.refInformProduct?.refToWhom?.refCountry?.nameEnS )})   
        })
    ];
    data.manageExtras = [];
    data.rowActions = [];
    onMounted(() => {
        const interval = setInterval(() => {
            if (refs.table) {
                if (data.useForm?.modelRef?.refToWhomTemp?.refInformProduct?.id) {
                    refs.table.data.rowSelection.selectedRowKeys.push(data.useForm?.modelRef?.refToWhomTemp?.refInformProduct.id);
                    refs.table.data.rowSelection.selectedRows.push(data.useForm?.modelRef?.refToWhomTemp?.refInformProduct);
                }
                clearInterval(interval);
            }
        }, 100);
    });
};
